import Skeleton from '@mui/material/Skeleton';
import { Box } from 'src/components/Box';
import { Card, CardActionArea, CardContent } from 'src/components/Card';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { ImageOrLogo } from 'src/shared/ImageOrLogo';

interface ListCardProps {
  imageUrl?: string;
  onClick?: () => void;
  primary: string;
  secondary: string;
  bottom?: React.ReactNode;
  additionalDetails?: React.ReactNode;
}

export function ListCard({
  imageUrl,
  onClick,
  primary,
  secondary,
  bottom,
  additionalDetails,
}: ListCardProps) {
  return (
    <Card>
      <CardActionArea onClick={onClick}>
        <CardContent
          sx={{
            p: 2,
            pb: (theme) => {
              return `${theme.spacing(2)} !important`;
            },
          }}
        >
          <Stack spacing={3}>
            <Stack direction="row" spacing={2} alignItems="center">
              <ImageOrLogo imageUrl={imageUrl} height={66} width={80} />
              <Stack spacing={1}>
                <Typography variant="h6">{primary}</Typography>
                <Typography>{secondary}</Typography>
              </Stack>
            </Stack>
            {bottom && <Typography color="text.secondary">{bottom}</Typography>}
            {additionalDetails}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

interface ListCardSummaryProps {
  imageUrl?: string;
  primary: string;
  secondary: string;
}

export function ListCardSummary({
  imageUrl,
  primary,
  secondary,
}: ListCardSummaryProps) {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <ImageOrLogo imageUrl={imageUrl} height={66} width={80} />
      <Stack spacing={1}>
        <Typography variant="h6">{primary}</Typography>
        <Typography>{secondary}</Typography>
      </Stack>
    </Stack>
  );
}

export function ListCardSkeleton() {
  return (
    <Card>
      <CardContent sx={{ p: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box>
            <Skeleton variant="rectangular" height={64} width={80} />
          </Box>
          <Stack spacing={1}>
            <Typography variant="h6">
              <Skeleton width={150} />
            </Typography>
            <Typography>
              <Skeleton width={170} />
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
